<template>
  <div
    class="square-icon-wrap h-w-32 header-icon group"
    :class="[{ 'header-icon-active': commentsActive }, { 'disabled-item': pageNotFound }]"
    @click="handleClick"
  >
    <em
      :style="getCustomIconStyle(iconPath('message-square'))"
      class="custom-icons header-comments group-hover:bg-icon-hover"
      :class="{ disabled: pageNotFound }"
    />
    <transition
      name="popin-count"
      mode="out-in"
    >
      <span
        v-if="displayCount"
        :key="pageCommentsCount"
        class="comments-count"
      >
        {{ pageCommentsCount }}
      </span>
    </transition>
  </div>
</template>

<script>
import pageNotFound from '@/mixins/pageNotFound';
import customIconsMixin from '@/mixins/customIconsMixin';
import hideDropdownsMixin from '@/mixins/hideDropdownsMixin';

export default {
  name: 'CommentPageButton',

  mixins: [pageNotFound, customIconsMixin, hideDropdownsMixin],

  computed: {
    commentsActive() {
      return this.$store.getters.getCommentsAreActive;
    },
    displayCount() {
      return parseInt(this.pageCommentsCount, 10) > 0;
    },
    pageCommentsCount() {
      return (this.$store.getters.getPage || {})?.total_comments || 0;
    },
  },

  unmounted() {
    this.$store.dispatch('setCommentsAreActive', false);
    this.$store.dispatch('setCurrentEditCommentID', '');
  },

  methods: {
    handleClick() {
      if (this.pageNotFound) return;
      if (!this.commentsActive) {
        this.$store.dispatch('displayInfoSidebar', false);
        this.$store.dispatch('hideAllReplies');
        this.$store.dispatch('closeEditor');
      }
      this.$store.dispatch('setCommentsAreActive', !this.commentsActive);
      this.$store.dispatch('setCurrentEditCommentID', '');
    },
  },
};
</script>
<style lang="scss">
.square-icon-wrap {
  .comments-count {
    position: absolute;
    padding: 1px 2px;
    font-size: 10px;
    font-weight: bold;
    line-height: 13px;
    letter-spacing: 0.4px;
    top: -3px;
    left: 16px;
    height: 13px;
    min-width: 15px;
    text-align: center;
    color: $white;
    border: 2px solid;
    border-radius: 8px;
    @apply bg-attention-bg text-attention-text border-background-strongest;
  }
}

.popin-count-enter-active {
  transition: all 125ms ease;
}

.popin-count-leave-active {
  transition: all 125ms ease-in-out;
}

.popin-count-enter,
.popin-count-leave-to {
  transform: scale3d(0, 0, 0);
  opacity: 0;
}
</style>
